import Input from '../../../components/forms/Input'
import React, { useEffect, useState } from 'react'
import { uniq } from 'lodash'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { StyledFieldSet, StyledLegend, StyledSpan } from 'components/StyledElements'
import { Grid, Button, Stack } from '@mui/material'
import Select from 'components/forms/Select'
import RadioButtons from '../../../components/forms/RadioButtons'
import { CardTable } from '../../../components/datatable/NewTable'
import { exportFile } from '../../../utils/ExportDataUtil'
import { readImportCsvStationsCodes } from '../../../import/components/utils/ImportUtils'
import { CITIES, DEPARTMENTS } from 'traitements/constants/TraitementConstants'
import { shallowEqual, useSelector } from 'react-redux'

const HEADER = ['code', 'name']

const CodeChoicePanel = ({
    choiceTypeCode,
    setChoiceTypeCode,
    listCode,
    setListCode,
}) => {
    const {
        cities,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
    }), shallowEqual)

    useEffect(() => {
        if (!choiceTypeCode) {
            setChoiceTypeCode(CITIES)
        }
    }, [])

    const codesTypes = [
        { code: CITIES, name: i18n.cities },
        { code: DEPARTMENTS, name: i18n.departments },
    ]

    const [newCode, setNewCode] = useState('')

    const stationsCodes = listCode.map(code => ({
        code,
        name: cities.find(city => city.id === code)?.name || '',
    }))

    const onDeleteHydroCode = ({ code }) => {
        setListCode(prev => prev.filter(item => item !== code))
    }

    const onChangeBssFile = e => {
        readImportCsvStationsCodes(e, { importFile: e.target }, codes => {
            setListCode(prev => uniq([...prev, ...codes]))
        })
    }

    const handleAdd = () => {
        if (!newCode) return
        setListCode(prev => prev.includes(newCode) ? prev: [...prev, newCode])
        setNewCode('')
    }

    const isInputMode = [DEPARTMENTS].includes(choiceTypeCode)

    return (
        <StyledFieldSet>
            <StyledLegend>
                <StyledSpan>{i18n.options}</StyledSpan>
            </StyledLegend>

            <Grid container mb={2} spacing={8}>
                <Grid size={4}>
                    <RadioButtons
                        elements={codesTypes}
                        selected={choiceTypeCode}
                        onChange={v => setChoiceTypeCode(v)}
                        title={i18n.schemeAgencyID}
                    />
                </Grid>
            </Grid>

            <Grid container mb={2} spacing={8}>
                <Grid size={6}>
                    {isInputMode ? (
                        <Input
                            id='txtAddHydroCode'
                            type='text'
                            value={newCode}
                            onChange={v => setNewCode(v)}
                            title={i18n.code}
                            obligatory
                            onEnterKeyPress={handleAdd}
                            noSpace
                        />
                    ) : (
                        <Select
                            label={i18n.city}
                            options={cities}
                            value={newCode}
                            onChange={v => setNewCode(v)}
                            keyValue='id'
                            obligatory
                            displayWithCode
                        />
                    )}
                </Grid>

                <Grid container size={6} spacing={4}>
                    <Button
                        onClick={handleAdd}
                        variant='contained'
                    >
                        {i18n.add}
                    </Button>

                    <Button
                        variant='contained'
                        component='label'
                    >
                        {i18n.importLabelStation}
                        <input
                            type='file'
                            accept='.csv'
                            hidden
                            onChange={onChangeBssFile}
                        />
                    </Button>
                </Grid>
            </Grid>

            <Stack spacing={4}>
                <CardTable
                    headers={HEADER}
                    rows={stationsCodes}
                    title={i18n.add}
                    lineActions={[
                        {
                            icon: 'delete',
                            onClick: onDeleteHydroCode,
                        },
                    ]}
                    actions={[
                        {
                            icon: 'download',
                            onClick: () => exportFile({
                                data: [
                                    { ...stationsCodes[0], headers: HEADER },
                                    ...stationsCodes.slice(1),
                                ],
                                titleFile: i18n.credentials,
                            }),
                            tooltip: i18n.download,
                        },
                    ]}
                    displayHeaders
                />
            </Stack>
        </StyledFieldSet>
    )
}

CodeChoicePanel.propTypes = {
    choiceTypeCode: PropTypes.string,
    setChoiceTypeCode: PropTypes.func,
    listCode: PropTypes.any,
    setListCode: PropTypes.func,
}

export default CodeChoicePanel